/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'redux/store';
import SearchClientBar from '../../Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/search-client-bar/SearchClientBar';
import {
    SearchbarContainer,
    SearchbarContainerMobileForDashboard,
    TopContainer,
} from '../../Dashboards-B2B/Dashboard.styled';
import { useWindowSize } from 'hooks/useWindowSize';
import { PaginatedItems } from 'components/common/pagination';
import { useTranslation } from 'react-i18next';
import AdminTable from './components/AdminTable';
import { loadAdminUsers } from 'redux/admin-users/admin-users.middleware';
import { AdminUsers } from 'api/models/response/AdminUsers';
import { CompanyData } from 'api/models/response/CompaniesList';
import SelectCompanyDropdown from 'views/ProviderProfile/ClientSummary/SelectCompanyDropdown';
import api from 'api';
import { AdminPanelWrapper } from './AdminPanel.styled';

const AdminPanel = () => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const {
        list: adminUsers,
        isLoading: isAdminUsersLoading,
        page,
        pageSize,
        totalRecords,
    } = useSelector((state: RootState) => state.adminUsers);
    const [searchInput, setSearchInput] = useState<any>();
    const [adminUsersForTable, setAdminUsersForTable] = useState<AdminUsers[]>([]);
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);
    const [companies, setCompanies] = useState<CompanyData | null>(null);
    const [selectedCompany, setSelectedCompany] = useState<CompanyData | string>(
        t('selectCompany', { lng: language })
    );

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    useEffect(() => {
        const initialPage = 1;
        dispatchAdminUsers(initialPage, pageSize, searchInput, selectedCompany);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany, searchInput]);

    const handlePageNumber = (val: number) => {
        dispatchAdminUsers(val, pageSize, searchInput, selectedCompany);
    };

    const reloadClients = () => {
        dispatchAdminUsers(page, pageSize, searchInput, selectedCompany);
    };

    const dispatchAdminUsers = (
        pageVal: number,
        pageSizeVal: number,
        query: string,
        company_name: any
    ) => {
        const paginationValues: any = {
            page: pageVal,
            pageSize: pageSizeVal,
        };

        if (query) {
            paginationValues.name = query;
        }

        if (company_name !== t('selectCompany', { lng: language }) && company_name !== '') {
            paginationValues.company_name = company_name;
        }

        dispatch(loadAdminUsers(paginationValues));
    };

    useEffect(() => {
        const fetchCompaniesList = async () => {
            try {
                const response = await api.companies.getCompanies();
                setCompanies(response.data);
            } catch (e) {
                console.error(e);
            }
        };
        fetchCompaniesList();
    }, []);

    return (
        <AdminPanelWrapper>
            <h1>{t('adminPanel', { lng: language })}</h1>
            {mobile ? (
                <SearchbarContainerMobileForDashboard>
                    <TopContainer mobile={mobile}>
                        <SelectCompanyDropdown
                            mobile={mobile}
                            dashboard={mobile}
                            companies={companies}
                            selectedCompany={
                                typeof selectedCompany === 'string'
                                    ? selectedCompany
                                    : selectedCompany[1]
                            }
                            handleSelectedCompany={setSelectedCompany}
                        />
                    </TopContainer>
                    <SearchClientBar
                        mobile={mobile}
                        handleSearchInput={setSearchInput}
                        placeHolder={t('nameOrEmail', { lng: language })}
                    />
                </SearchbarContainerMobileForDashboard>
            ) : (
                <SearchbarContainer mobile={mobile}>
                    <>
                        <SelectCompanyDropdown
                            mobile={mobile}
                            dashboard={true}
                            companies={companies}
                            selectedCompany={
                                typeof selectedCompany === 'string'
                                    ? selectedCompany
                                    : selectedCompany[1]
                            }
                            handleSelectedCompany={setSelectedCompany}
                        />
                        <SearchClientBar
                            mobile={mobile}
                            handleSearchInput={setSearchInput}
                            placeHolder={t('nameOrEmail', { lng: language })}
                        />
                    </>
                </SearchbarContainer>
            )}

            <AdminTable
                mobile={mobile}
                adminUsers={adminUsers}
                adminUsersForTable={adminUsersForTable}
                setAdminUsersForTable={setAdminUsersForTable}
                isAdminUsersLoading={isAdminUsersLoading}
                reloadClients={reloadClients}
            />
            <span
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                }}
            >
                <PaginatedItems
                    itemsPerPage={pageSize}
                    numberOfItems={totalRecords}
                    handleClick={handlePageNumber}
                    pageNumber={page}
                />
            </span>
        </AdminPanelWrapper>
    );
};

export default AdminPanel;
